<template>
  <div class="bookings">

    <div class="title-button">

      <h1>Bookings</h1>

      <router-link to="/bookings/create" class="button p-3" v-if="userRole == 1">New booking</router-link>

    </div>

    <div class="box">
      <form @submit.stop.prevent="doSearch">
        <div class="row">
          <div class="col-md-12">
            <div class="box__header">
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="search_by_ref" class="form-label">Search By Ref.</label>
                    <input type="text" name="search_by_ref" class="form-control" placeholder="Search By ref." v-model="searchFields.search_by_ref">
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="" class="form-label"> Booking for </label>
                    <select class="form-control" placeholder="Booking For" v-model="searchFields.booking_for" style="height: 38px;">
                      <option>Select</option>
                      <option value="customer">Customer</option>
                      <option value="agent">Agent</option>
                      <option value="affiliate">affiliate</option>
                      <option value="air_line_ref">Airline Reference</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3" v-if="['customer','agent','affiliate','air_line_ref'].includes(searchFields.booking_for)">
                  <template v-if="searchFields.booking_for == 'customer'">
                    <div class="form-group">
                      <label for="" class="form-label"> Search By Customer </label>
                      <v-select
                        :options="bookingFilters.customers"
                        label="full_name"
                        v-debounce:500ms="fetchCustomers"
                        placeholder="Select Customer..." 
                        index="id"
                        v-model="searchFields.selected_customer_id">
                        <template slot="no-options">
                          Please Type Customer name/Postcode
                        </template>
                      </v-select>
                    </div>
                  </template>
                  <template v-if="searchFields.booking_for == 'agent'">
                    <div class="form-group">
                      <label for="" class="form-label"> Search By Agent </label>
                      <v-select
                        label="name"
                        placeholder="Search by Agent."
                        id="search_by_agent"
                        index="id"
                        v-model="searchFields.selected_agent_id"
                        :options="bookingFilters.agents"
                      />
                    </div>
                  </template>
                  <template  v-if="searchFields.booking_for == 'affiliate'">
                    <div class="form-group">
                      <label for="" class="form-label"> Search By Affiliate </label>
                      <v-select
                        label="name"
                        placeholder="Search by Affiliate."
                        id="search_by_affiliate"
                        index="id"
                        v-model="searchFields.selected_affiliate_id"
                        :options="bookingFilters.affiliates"
                      />
                    </div>
                  </template>
                  <template  v-if="searchFields.booking_for == 'air_line_ref'">
                    <label for="search_by_airline_ref" class="form-label">Airline Ref.</label>
                    <input type="text" name="search_by_airline_ref" class="form-control" placeholder="Airline Reference" v-model="searchFields.search_by_airline_ref">
                  </template>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="" class="form-label">Booking Date Range</label>
                    <template>
                      <date-range-picker v-model="searchFields.BookingdateRange" format="mm/dd/yyyy" @update="checkOpenPicker('booking')" opens="center" class="form-control">
                          <!-- header slot-->
                          <div slot="header" slot-scope="header" class="slot-date-range-picker">
                            <h3 class="m-0">Calendar header</h3> <span v-if="header.in_selection"> - in selection</span>
                          </div>
                          <!-- input slot (new slot syntax) -->
                          <template #input="picker">
                            {{ picker.startDate | date }} - {{ picker.endDate | date }}
                          </template>
                          <!-- date slot-->
                          <template #date="data">
                            <span class="small">{{ data.date | dateCell }}</span>
                          </template>
                          <!-- ranges (new slot syntax) -->
                          <template #ranges="ranges">
                              <div class="ranges">
                                <ul>
                                  <li v-for="(range, name) in ranges.ranges" :key="name" @click="ranges.clickRange(range)">
                                    <b>{{ name }}</b> <small class="text-muted">{{ range[0].toDateString() }} - {{ range[1].toDateString() }}</small>
                                  </li>
                                </ul>
                              </div>
                          </template>
                          <!-- footer slot -->
                          <div slot="footer" slot-scope="data" class="slot-date-range-picker">
                              <div class="p-2">
                                <b class="text-black">Calendar footer</b> {{ data.rangeText }}
                              </div>
                              <div style="margin-left: auto">
                                <a @click="data.clickApply" v-if="!data.in_selection" class="btn btn-primary btn-sm">Choose current</a>
                              </div>
                          </div>
                      </date-range-picker>
                    </template>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="" class="form-label">Departure Date Range</label>
                    <template>
                      <date-range-picker v-model="searchFields.DeparturedateRange" format="mm/dd/yyyy" @update="checkOpenPicker('departure')" opens="center" class="form-control">
                          <!-- header slot-->
                          <div slot="header" slot-scope="header" class="slot-date-range-picker">
                            <h3 class="m-0">Calendar header</h3> <span v-if="header.in_selection"> - in selection</span>
                          </div>
                          <!-- input slot (new slot syntax) -->
                          <template #input="picker">
                            {{ picker.startDate | date }} - {{ picker.endDate | date }}
                          </template>
                          <!-- date slot-->
                          <template #date="data">
                            <span class="small">{{ data.date | dateCell }}</span>
                          </template>
                          <!-- ranges (new slot syntax) -->
                          <template #ranges="ranges">
                              <div class="ranges">
                                <ul>
                                  <li v-for="(range, name) in ranges.ranges" :key="name" @click="ranges.clickRange(range)">
                                    <b>{{ name }}</b> <small class="text-muted">{{ range[0].toDateString() }} - {{ range[1].toDateString() }}</small>
                                  </li>
                                </ul>
                              </div>
                          </template>
                          <!-- footer slot -->
                          <div slot="footer" slot-scope="data" class="slot-date-range-picker">
                              <div class="p-2">
                                <b class="text-black">Calendar footer</b> {{ data.rangeText }}
                              </div>
                              <div style="margin-left: auto">
                                <a @click="data.clickApply" v-if="!data.in_selection" class="btn btn-primary btn-sm">Choose current</a>
                              </div>
                          </div>
                      </date-range-picker>
                    </template>
                  </div>
                </div>
                <!-- <div class="col-md-3">
                  <div class="form-group">
                    <label for="" class="form-label"> Payment Status </label>
                    <select class="form-control" name="" id="" placeholder="Payment Status" v-model="searchFields.payment_status">
                      <option>Select</option>
                      <option value="Confirmed">Confirmed</option>
                      <option value="Paid">Paid</option>
                      <option value="Pending">Pending</option>
                      <option value="Cancelled">Cancelled</option>
                      <option value="Cancelled Pending">Cancelled Pending</option>
                    </select>
                  </div>
                </div> -->
              </div>
              <div class="row mt-3">
                <div class="col-md-3">
                  <button class="button button--large ms-2" type="submit"><span> Search Bookings</span></button>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </form>
      <hr />
      <vdtnet-table
        ref="table"
        :fields="fields"
        :opts="options"
        :key="tableKey"
        @edit="viewBooking"
        @viewTour="viewTour"
        @viewCustomer="viewCustomer"
        @viewOldCustomer="viewOldCustomer"
        @viewAgent="viewAgent"
        @viewOldAgent="viewOldAgent"
        @viewAffiliate="viewAffiliate"
        @viewOldAffiliate="viewOldAffiliate"
        >
      </vdtnet-table>

    </div>

  </div>
</template>

<script>
import 'datatables.net'
import moment from 'moment'
import VdtnetTable from 'vue-datatables-net'

export default {
  name: 'bookings',
  components: {
    VdtnetTable,
  },
  computed: {
    userRole() {
      let user_role = localStorage.getItem("user_role");
      if (user_role == 1) {
        // this.showPassenger = true
      }
      return user_role
    }
  },
  created () {
    this.getBookingFilterData()
  },
  filters: {
    dateCell (value) {
      let dt = new Date(value)

      return dt.getDate()
    },
    date (val) {
      return val ? val.toDateString() : ''
    }
  },
  data() {
    return {
      options: {
        ajax: {
          url: this.$api + 'bookings/table',
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        },
        responsive: false,
        processing: true,
        searching: true,
        searchDelay: 1500,
        destroy: true,
        ordering: true,
        lengthChange: true,
        serverSide: true,
        dom: 'rtlip',
        autoWidth: false,
        lengthMenu: [ [25, 50, 100, 500], [25, 50, 100, 500] ],
        pageLength: 25,
        order: [[6, 'desc']]        
      },
      fields: {
        booking_ref: {
          label: 'Booking ref.',
          render: (data, type, row) => {
            if(row.cancelled_at) {
              return `<del><a href="/bookings/edit/${ row.id }" data-action="edit">${ data }</a></del>`
            } else {
              return `<a href="/bookings/edit/${ row.id }" class="${ (row.changes_accepted == 0) ? 'color-orange' : '' }" data-action="edit">${ data }</a>`
            }
          }
        },
        departure_date: {
          searchable: false,
          label: 'Departure date',
          render: (data) => {
            return (data !== null ? moment(data, "YYYY-MM-DD").format('DD/MM/YYYY') : '–')
          }
        },
        customer: {
          searchable: false,
          label: 'Customer',
          render: (data, type, row) => {
            console.log(data);
            
            if(data !== null) {
              return `<a href="/customers/edit/${ row.customer_id }" data-action="viewCustomer" class="${(data.is_blacklisted) ? 'black_list' : ''}">${ data.first_name } ${ data.last_name } ${ (data.is_blacklisted) ? '(Blacklisted)' : '' }</a>`
            } else if(row.old_customer !== null) {
              return `<a href="/customers/edit/${ row.old_customer.id }"  data-action="viewOldCustomer">${ row.old_customer.first_name} ${ row.old_customer.last_name}</a>`
            } else {
              return '-'
            }
          }
        },
        agent: {
          searchable: false,
          label: 'Agent',
          render: (data, type, row) => {
            if(data !== null) {
              return `<a href="/agents/edit/${ row.agent_id }" data-action="viewAgent">${ data.name }</a>`
            } else if(row.old_agent !== null) {
              return `<a href="/agents/edit/${ row.old_agent.id }"  data-action="viewOldAgent">${ row.old_agent.name}</a>`
            } else {
              return '-'
            }
          }
        },
        affiliate: {
          searchable: false,
          label: 'Affiliate',
          render: (data, type, row) => {
            if(data !== null) {
              return `<a href="/affiliates/edit/${ row.affiliate_id }" data-action="viewAffiliate">${ data.name }</a>`
            } else if(row.old_affiliate !== null) {
              return `<a href="/affiliates/edit/${ row.old_affiliate.id }"  data-action="viewOldAffiliate">${ row.old_affiliate.name}</a>`
            } else {
              return '-'
            }
          }
        },
        created_at: {
          label: 'Booking date',
          defaultOrder: 'desc',
          render: (data) => {
            return (data !== null ? moment(data, "YYYY-MM-DD HH:mm:ss").format('DD/MM/YYYY H:mm') : '–')
          }
        },
        actions: {
          sortable: false,
          searchable: false,
          label: ' ',
          render: (data, type, row) => {
            return `<a href="/bookings/edit/${ row.id }" data-action="edit" class="icon icon--more">Edit</a>`
          }
        }
      },
      quickSearch: '',
      bookingFilters: {
        customers:[],
        agents:[],
        affiliates:[],
      },
      searchFields: {
          BookingdateRange: {
            startDate : '',
            endDate : '',
          },
          DeparturedateRange: {
            startDate : '',
            endDate : '',
          },
          
      },
      tableKey: 0, // Key attribute to force re-render of the table
    }
  },
  methods: {
    doSearch() {
      // this.$refs.table.search(this.quickSearch)

      const ajaxUrl = this.$api + 'bookings/table'

      const queryString = new URLSearchParams();

      if(this.searchFields.search_by_ref){
        queryString.set('search_by_ref', this.searchFields.search_by_ref);
      }

      if(this.searchFields.BookingdateRange.startDate && this.searchFields.BookingdateRange.endDate){
        queryString.set('search_by_booking_start', this.searchFields.BookingdateRange.startDate);
        queryString.set('search_by_booking_end', this.searchFields.BookingdateRange.endDate);
      }

      if(this.searchFields.DeparturedateRange.startDate && this.searchFields.DeparturedateRange.endDate){
        queryString.set('search_by_departure_start', this.searchFields.DeparturedateRange.startDate);
        queryString.set('search_by_departure_end', this.searchFields.DeparturedateRange.endDate);
      }

      if(this.searchFields.selected_customer_id){
        queryString.set('search_by_customer', this.searchFields.selected_customer_id);
      }

      if(this.searchFields.selected_agent_id){
        queryString.set('search_by_agent', this.searchFields.selected_agent_id);
      }

      if(this.searchFields.selected_affiliate_id){
        queryString.set('search_by_affiliate', this.searchFields.selected_affiliate_id);
      }

      if(this.searchFields.search_by_airline_ref){
        queryString.set('search_by_airline_ref', this.searchFields.search_by_airline_ref);
      }

      const urlWithParams = `${ajaxUrl}?${queryString.toString()}`;

      // Update the datatable's AJAX URL with the Start Date & End Date query parameters
      this.options.ajax.url = urlWithParams;

      // Increment the tableKey to force re-render and fetch new data
      this.tableKey++;

    },
    viewBooking(data) {
      this.$router.push({ name: 'booking-edit', params: { id: data.id }})
    },
    viewCustomer(data) {
      this.$router.push({ name: 'customer-edit', params: { id: data.customer_id }})
    },
    viewOldCustomer(data) {
      this.$router.push({ name: 'customer-edit', params: { id: data.old_customer.id }})
    },
    viewAgent(data) {
      this.$router.push({ name: 'agent-edit', params: { id: data.agent_id }})
    },
    viewOldAgent(data) {
      this.$router.push({ name: 'agent-edit', params: { id: data.old_agent.id }})
    },
    viewAffiliate(data) {
      this.$router.push({ name: 'affiliate-edit', params: { id: data.affiliate_id }})
    },
    viewOldAffiliate(data) {
      this.$router.push({ name: 'affiliate-edit', params: { id: data.old_affiliate.id }})
    },
    viewTour(data) {
      this.$router.push({ name: 'tour-edit', params: { id: data.tour_id }})
    },
    doExport(type) {
      const parms = this.$refs.table.getServerParams()
      parms.export = type
      // window.alert('GET /api/v1/export?' + jQuery.param(parms))
    },
    getBookingFilterData() {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'get-booking-filters-data', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        if (response.status) {
          let { agents, affiliates } = response.data
          this.bookingFilters.agents = agents
          this.bookingFilters.affiliates = affiliates
        }
        this.$store.dispatch('setLoadStatus')
      })
    },
    checkOpenPicker(pickerType) {
      // Set Booking Dates
      if (pickerType == 'booking') {
        this.searchFields.BookingdateRange.startDate = moment(this.searchFields.BookingdateRange.startDate).format('YYYY-MM-DD');
        this.searchFields.BookingdateRange.endDate = moment(this.searchFields.BookingdateRange.endDate).format('YYYY-MM-DD');
      }

      // Set Departure Dates
      if (pickerType == 'departure') {
        this.searchFields.DeparturedateRange.startDate = moment(this.searchFields.DeparturedateRange.startDate).format('YYYY-MM-DD');
        this.searchFields.DeparturedateRange.endDate = moment(this.searchFields.DeparturedateRange.endDate).format('YYYY-MM-DD');
      }
    },

    fetchCustomers (search) {
      fetch(`${this.$api}customers/filtered/list`, {
        method: 'POST',
        body: JSON.stringify({search}),
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(response => response.json())
      .then(response => {
        if (search) {
          this.bookingFilters.customers = response.data
        } else {
          this.bookingFilters.customers = [...this.bookingFilters.customers, ...response.data]
        }
      })
      .catch(error => {
        console.error(error)
      })
      .finally(() => {
        this.isLoading = false
        // loading(false)
      })
    },
  }
}

</script>

<style scoped>

.slot-date-range-picker {
  background-color: #aaa;
  padding: 0.5rem;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.slot-date-range-picker h3 {
  font-size: 1.0625rem;
}

.text-black {
  color: #000;
}

</style>
